import React, { useState } from "react";
import { Modal, Col, Flex } from "antd";
import Keywords from "../Cards/Keywords";
import AIConfiguration from "../Cards/AIConfiguration";
import { sellBoostFetch } from "../../utlifyFunction";
import { toast } from "react-toastify";
import PrimaryButton from "../Buttons/PrimaryButton";

export default function CreateBulkOrderConfigurations({
	isModalVisible,
	setIsModalVisible,
    submitOrder
}) {
	const [keywords, setKeywords] = useState("");
	const [loading, setLoading] = useState(false);
	const [showAIInputs, setShowAIInputs] = useState(false);
	const [numberOfKeywords, setNumberOfKeywords] = useState("");
	const [keywordCountry, setKeywordCountry] = useState("");
	const [keywordTopic, setKeywordTopic] = useState("");
	const [isButtonLoading, setIsButtonLoading] = useState(false);
	const [tone, setTone] = useState("Professional");
	const [maxWords, setMaxWords] = useState(50);
	const [targetAudience, setTargetAudience] = useState("");
	const [productType, setProductType] = useState("Other");
	const [ctaType, setCtaType] = useState("Urgency");

	const handleGenerateKeywords = async () => {
		setLoading(true);
		try {
			const response = await sellBoostFetch("POST", "/AI/getTrendingKeywords", {
				numberOfKeywords,
				country: keywordCountry,
				topicRelatedTo: keywordTopic,
			});
			if (response?.keywords) {
				setKeywords(response.keywords.join(",").replaceAll('"'));
				toast.success("Keywords generated successfully!");
			}
		} catch (error) {
			toast.error("Failed to generate keywords.");
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = () => {
		if (!keywords) {
			toast.error("Please generate or enter keywords");
			return;
		}

		if (!targetAudience) {
			toast.error("Please specify target audience");
			return;
		}

		if (maxWords <= 0) {
			toast.error("Max words must be greater than 0");
			return;
		}

		submitOrder({
			keywords,
			tone,
			maxWords,
			targetAudience,
			productType,
			ctaType
		});
	};

	return (
		<Modal
			title="Configure AI Generation"
			open={isModalVisible}
			onCancel={() => setIsModalVisible(false)}
			footer={null}
			width={600}
		>
			<Flex vertical gap={24}>
				<Col span={24}>
					<Keywords
						keywords={keywords}
						setKeywords={setKeywords}
						loading={loading}
						showAIInputs={showAIInputs}
						setShowAIInputs={setShowAIInputs}
						numberOfKeywords={numberOfKeywords}
						setNumberOfKeywords={setNumberOfKeywords}
						keywordCountry={keywordCountry}
						setKeywordCountry={setKeywordCountry}
						keywordTopic={keywordTopic}
						setKeywordTopic={setKeywordTopic}
						isButtonLoading={isButtonLoading}
						handleGenerateKeywords={handleGenerateKeywords}
					/>
				</Col>

				<Col span={24}>
					<AIConfiguration
						tone={tone}
						setTone={setTone}
						maxWords={maxWords}
						setMaxWords={setMaxWords}
						targetAudience={targetAudience}
						setTargetAudience={setTargetAudience}
						productType={productType}
						setProductType={setProductType}
						ctaType={ctaType}
						setCtaType={setCtaType}
					/>
				</Col>
                <Flex justify="end">
				<PrimaryButton 
					type="primary" 
					onClick={handleSubmit}
					loading={loading}
				>
					Submit Order
				</PrimaryButton>
			</Flex>
			</Flex>
		</Modal>
	);
}
